import PageItem from './PageItem';

export default PageItem;
